import server from "../Server";
import withErrorCheck from "../CheckError";
import moment from "moment";
import { AddPlayertToGameByEmailRequest } from "@grassrootly/api/entities";

export const AddPlayerToGameByEmail = async (payload: AddPlayertToGameByEmailRequest) => {
  const redirectTo = payload?.redirectTo ?? process.env.EXPO_PUBLIC_REST_PASSWORD_URL;

  // 1) Find or create player
  let player = null;
  let isNewPlayer = false;

  if (payload.email) {
    // If email provided, check if player exists
    let playerResp = await server.from("Players").select("*").eq("email", payload.email).limit(1);
    player = withErrorCheck(playerResp)?.[0] ?? null;
    isNewPlayer = !player;
  }

  if (!player) {
    // Create new player (with or without email)
    const playerData: any = {
      name: payload.name,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
    
    // Only add email if provided
    if (payload.email) {
      playerData.email = payload.email;
    }
    
    const insertResp = await server
      .from("Players")
      .insert(playerData)
      .select()
      .single();
    player = withErrorCheck(insertResp);
    isNewPlayer = true;
  }

  // 2) Guard: already attending?
  const attendanceCheckResp = await server
    .from("GameAttendances")
    .select("*")
    .eq("game_id", payload.game_id)
    .eq("player_id", player.id)
    .limit(1);
  const existingAttendance = withErrorCheck(attendanceCheckResp)?.[0] ?? null;
  if (existingAttendance) throw new Error("Player is already attending the game.");

  // 3) Insert attendance
  const insertAttendanceResp = await server
    .from("GameAttendances")
    .insert({
      game_id: payload.game_id,
      player_id: player.id,
      attended: true,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    })
    .select()
    .single();
  const attendance = withErrorCheck(insertAttendanceResp);

  // 4) Send OTP magic link only if the player is new and has email; rollback on failure
  let sent_magic_link = false;
  if (isNewPlayer && payload.email) {
    const { error: otpErr } = await server.auth.signInWithOtp({
      email: payload.email,
      options: { emailRedirectTo: redirectTo },
    });
    if (otpErr) {
      // rollback both inserts made in this call
      await server.from("GameAttendances").delete().eq("id", attendance.id);
      await server.from("Players").delete().eq("id", player.id);
      throw otpErr;
    }
    sent_magic_link = true;
  }

  return {
    match_id: payload.game_id,
    player_id: player.id,
    joined_match: true,
    sent_magic_link,
  };
};
